import React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { CrossIcon } from "../../assets/constant";
import classes from "./MySelect.module.css"
const MySelect = ({
  name,
  value,
  label,
  setter,
  options,
  error,
  disabled = false,
  width = "100%",
  multiple = false, // Add multiple prop to control multi-select
  extraStyles = {},
  onKeyChange = () => { },
  noDataFallbackText = "No data found", // New prop with default value
  showFallback = true, // New prop to control whether to show fallback
  readOnly = false,
  clearable = true,

  handleClear,
}) => {
  // Check if options are empty or null
  const hasOptions = options && options.length > 0;

  // Function to handle changes in the select box
  const handleChange = (event) => {
    const {
      target: { value: selectedValues },
    } = event;

    // Don't allow selection of fallback option
    if (!hasOptions) {
      return;
    }

    if (multiple) {
      if (selectedValues.includes("all")) {
        if (value.length === options.length) {
          // If all items are selected, deselect all
          setter([]);
        } else {
          // If not all items are selected, select all
          const allOptions = options.map((option) => ({
            label: option.label,
            value: option.value,
          }));
          setter(allOptions);
        }
      } else {
        const updatedValues = selectedValues
          .map((val) => {
            const selectedOption = options.find(
              (option) => option.value === val
            );
            return selectedOption
              ? { label: selectedOption.label, value: selectedOption.value }
              : null;
          })
          .filter(Boolean);
        setter(updatedValues);
      }
    } else {
      const selectedOption = options.find(
        (option) => option.value === selectedValues
      );
      setter(
        selectedOption
          ? { label: selectedOption.label, value: selectedOption.value }
          : null
      );
    }
  };

  const handleKeyChange = (event, name) => {

  }

  // Check if "All" should be selected
  const isAllSelected = multiple && hasOptions && value.length === options.length;

  return (
    <>
      <Box sx={{ minWidth: 120, width: width }}>
        <FormControl fullWidth error={!!error} className={classes.formControl}>
          <InputLabel id={`${name}-select-label`}>{label}</InputLabel>
          <Select
            labelId={`${name}-select-label`}
            id={`${name}-select`}
            value={
              multiple ? value.map((item) => item.value) : value?.value || ""
            }
            label={label}
            onChange={handleChange}
            onKeyDown={(e) => handleKeyChange(e, name)}
            multiple={multiple} // Enable multi-select
            renderValue={(selected) =>
              multiple
                ? selected
                  .map((selectedValue) => {
                    const selectedItem = hasOptions
                      ? options.find((option) => option.value === selectedValue)
                      : null;
                    return selectedItem ? selectedItem.label : selectedValue;
                  })
                  .join(", ")
                : hasOptions
                  ? options.find((option) => option.value === selected)?.label || ""
                  : ""
            }
            readOnly={readOnly || disabled}
            disabled={disabled}
            sx={{
              fontFamily: "Gilroy",
              borderRadius: "12px",
              backgroundColor: "var(--secondary-color)",
              ...extraStyles,
            }}
          >
            {/* Show fallback option when no data is available */}
            {!hasOptions && showFallback && (
              <MenuItem value="" disabled>
                <ListItemText primary={noDataFallbackText} />
              </MenuItem>
            )}

            {/* Show "All" option for multi-select when options are available */}
            {multiple && hasOptions && (
              <MenuItem value="all">
                <Checkbox checked={isAllSelected} />
                <ListItemText primary="All" />
              </MenuItem>
            )}

            {/* Show actual options when available */}
            {hasOptions && options.map((item, index) => (
              <MenuItem key={index} value={item?.value}>
                {multiple && (
                  <Checkbox
                    checked={value.some(
                      (selected) => selected.value === item?.value
                    )}
                  />
                )}
                <ListItemText primary={item?.label} />
              </MenuItem>
            ))}
          </Select>
          {/* {clearable && (multiple ? value.length > 0 : value) && (
            <Box
              sx={{
                position: "absolute",
                right: 5,
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
              onClick={handleClear}
            >
              <CrossIcon />
            </Box>
          )} */}
          {handleClear && value?.value && <span onClick={(e) => {
            e.stopPropagation();
            if (typeof handleClear === "function")
              handleClear()
          }} className={classes.clearBox}>

            <CrossIcon />
          </span>}
        </FormControl>
      </Box>
      {
        error &&
        <span
          style={{
            display: "inline-block",
            color: "red",
            fontSize: "14px",
            marginBottom: "5px",
          }}
        >
          {error}
        </span>
      }
    </>
  );
};

export default MySelect;